import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from 'react-router-dom';
const _ = require('lodash');
//904832009
export default function SiderBar() {
    const { user } = useSelector((state) => state.auth);
    const MyRole = JSON.parse(user && user.data.roles ? user.data.roles : '{}')
    const location = useLocation();
    let localsegment = location.pathname;
    const [showMenuChild, setShowMenuChild] = useState(null);

    let listMenus = [

        {
            title: 'Chiến dịch', icon: 'fab fa-adversal', link: '/campaign', active: ['/campaign'].includes(localsegment),
        },
        {
            title: 'Khách hàng của tôi', icon: 'fas fa-users', link: '/khach-hang-cua-toi', active: ['/khach-hang-cua-toi'].includes(localsegment),
        },
        {
            title: 'Khách hàng đã chốt', icon: 'fas fa-user-tie', link: '/khach-hang-da-chot', active: ['/khach-hang-da-chot'].includes(localsegment),
        },
        {
            title: 'QL Giao dịch & Khách hàng', icon: 'fas fa-chart-line', link: '', active: ['/giao-dich', '/khach-hang'].includes(localsegment), children: [
                 { title: 'Quản lý khách hàng', icon: 'fas fa-angle-right', link: '/khach-hang' },
                { title: 'Quản lý giao dịch', icon: 'fas fa-angle-right', link: '/giao-dich' },
            ]
        },
        {
            title: 'Sản phẩm', icon: 'fas fa-building', link: '', active: ['/du-an', '/chu-dau-tu', '/bang-hang'].includes(localsegment), children: [
                { title: 'Dự án', icon: 'fas fa-angle-right', link: '/du-an' },
                { title: 'Bảng hàng', icon: 'fas fa-angle-right', link: '/bang-hang' },
                { title: 'Chủ đầu tư', icon: 'fas fa-angle-right', link: '/chu-dau-tu' },
            ]
        },
        {
            title: 'Cài đặt chung', icon: 'fas fa-fas fa-cogs', link: '', active: ['/tags_settings', '/pipeline_settings', '/banghang_settings'].includes(localsegment), children: [
                { title: 'Quản lý thẻ', icon: 'fas fa-angle-right', link: '/tags_settings' },
                { title: 'Cài đặt Pipeline', icon: 'fas fa-angle-right', link: '/pipeline_settings' },
                { title: 'Cài đặt Bảng hàng', icon: 'fas fa-angle-right', link: '/banghang_settings' },
            ]
        },
        {
            title: 'Tài khoản', icon: 'fas fa-user-cog', link: '', active: ['/users'].includes(localsegment), children: [
                { title: 'Quản lý tài khoản', icon: 'fas fa-angle-right', link: '/users' },
                { title: 'Quản lý quyền hạn', icon: 'fas fa-angle-right', link: '/roles' },
            ]
        }
    ];

    const checkRole = (idparent, menu) => {
        let isrole = false;
        let id = menu.id;
        if (!id) id = _.trimStart(menu.link, ' /');
        if (id) {
            if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(id) && MyRole[idparent].children[id].checked === true) isrole = true
            else if (MyRole.hasOwnProperty(id) && MyRole[id].checked === true) isrole = true
        } else {
            if (menu.hasOwnProperty('children') && menu.children && menu.children.length > 0) {
                menu.children.map((sub) => {
                    let idsub = _.trimStart(sub.link, ' /');
                    if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(idsub) && MyRole[idparent].children[idsub].checked === true) isrole = true
                    else if (idsub && MyRole.hasOwnProperty(idsub) && MyRole[idsub].checked === true) isrole = true
                    return sub;
                })
            }
        }
        return isrole
    }


    const subMenu = (idparent, list, active) => {
        return <>
            {list && list.length > 0 ? <ul className={`nav sub-group-menu ` + (active ? 'menu-open' : '')} style={{ display: (active ? 'block' : 'none') }}>
                {list.map((item, i) => {
                    let title = item.title
                    title = <span>{title}</span>

                    if (checkRole(idparent, item)) {
                        return <li className="nav-item" key={i}>
                            <Link to={item.link} className={`nav-link ${item.link === localsegment ? 'active' : ''}`}>
                                <i className="dot"></i>
                                {title}
                            </Link>
                        </li>
                    } else return null
                })}
            </ul> : null}
        </>
    }

    return (
        <ul className="">
            {listMenus.map((item, i) => {
                if (checkRole(null, item) || item.role) {
                    let title = <span>{item.title}</span>;
                    let menuactive = false;
                    if (item.children) {
                        item.children.forEach((itemMN) => {
                            if (itemMN.link === localsegment) menuactive = true;
                        });
                    }

                    return (
                        <li key={i} className={`nav-item ${item.children ? 'sidebar-nav-item' : ''} ${menuactive ? 'active' : ''}`}>
                            {!item.children ? (
                                <a href={item.link} className={`${item.link === localsegment ? 'menu-active' : ''}`}>
                                    <i className={item.icon}></i>{title}
                                </a>
                            ) : (
                                <button
                                    type="button"
                                    className={`submenu ${menuactive || showMenuChild === i ? 'menu-active' : ''}`}
                                    onClick={() => setShowMenuChild(showMenuChild === i ? null : i)}
                                >
                                    <i className={item.icon}></i>{title}
                                    <i className={"cheven " + (menuactive || showMenuChild === i ? "fas fa-angle-up" : "fas fa-angle-down")}></i>
                                </button>
                            )}
                            {subMenu(item.id, item.children, menuactive || showMenuChild === i)}
                        </li>
                    );
                } else return null;
            })}
            <li className="nav-item">
                <button type='button' onClick={() => window.location.reload()} className="">
                    <i className="fas fa-crosshairs"></i><span>Tải lại trang</span>
                </button>
            </li>
            <li className="nav-item">
                <a href="/auth/logout" className="">
                    <i className="fas fa-power-off"></i><span>Đăng xuất</span>
                </a>
            </li>
        </ul>
    );
}
